

import __layout_0 from '/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarThemeSwitcher': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/codebuild/output/src446584707/src/lcx-new-ui/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
